export default __webpack_public_path__ + "static/media/layer09.ee10ae97.png";